export default __webpack_public_path__ + "locales/it/PDFFormDialog.json?hash=64041cbedd5de3b2227411aa27bdda83";